import { Avatar as PrimeAvatar } from 'primereact/avatar';

const Avatar = (props, { className }) => {
  return <PrimeAvatar image={props.src}  shape="circle" size="large" />;
};

export default Avatar;
